import clsx from "clsx";
import { AngleDoubleLeft } from "../icons/AngleDoubleLeft";
import { AngleDoubleRight } from "../icons/AngleDoubleRight";
import { ChevronLeft } from "../icons/ChevronLeft";
import { ChevronRight } from "../icons/ChevronRight";
import { PaginationLink } from "./PaginationLink";

type Props = {
  onClick: (event: React.ChangeEvent<unknown>) => void;
  type: string;
  page: number | null;
  selected: boolean;
  disabled: boolean;
  hidePageLink?: boolean;
};
export const PaginationItem = ({ onClick, type, page, selected, disabled, hidePageLink }: Props) => {
  if (type === "start-ellipsis" || type === "end-ellipsis") {
    return <div className="text-primary rounded-full w-10 h-10 grid place-items-center">…</div>;
  }

  if (type === "page" && page !== null && !hidePageLink) {
    return <PaginationLink onClick={onClick} page={page} selected={selected} disabled={disabled} />;
  }

  return (
    <div
      onClick={onClick}
      className={clsx("rounded-full w-10 h-10 grid place-items-center text-base leading-5 font-bold", {
        "text-primary": !selected,
        "bg-primary text-white": selected,
        "cursor-pointer hover:bg-primary/30": !disabled,
        "text-primary/30": disabled,
      })}
    >
      {type === "page" && page}
      {type === "previous" && <ChevronLeft className="w-[10px]" />}
      {type === "next" && <ChevronRight className="w-[10px]" />}
      {type === "first" && <AngleDoubleLeft className="w-[14px]" />}
      {type === "last" && <AngleDoubleRight className="w-[14px]" />}
    </div>
  );
};
